<mat-sidenav-container class="h-full w-full" autosize>
  <mat-sidenav mode="side" opened fixedInViewport="true" fixedTopGap="60" class="gcm-sidenav bg-white"
    [ngClass]="opened ? 'opened' : 'collapsed'">
    @if (opened) {
      <div class="my-2">
        <app-investor-dropdown class="lg:hidden" [updateWidth]="showMobileSideNav()"></app-investor-dropdown>
      </div>
    }
    <gcm-sidenav [(opened)]="opened" [navItems]="navigationItems" [defaultActiveOptions]="routerLinkActiveOptions" [showHorizontalDivider]="false" [expandOnResize]="false"></gcm-sidenav>
  </mat-sidenav>
  <mat-sidenav-content class="gcm-sidenav-content">
    <ng-template #defaultBodyTemplate><router-outlet></router-outlet></ng-template>
    <ng-container *ngTemplateOutlet="defaultBodyTemplate"></ng-container>
  </mat-sidenav-content>
</mat-sidenav-container>